import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expertkltp',
  templateUrl: './expertkltp.component.html',
  styleUrls: ['./expertkltp.component.scss']
})
export class ExpertkltpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
